import { ru } from 'date-fns/locale';
import { LocaleDefinition } from '../localeDefinition';
import messages from './ru.json';

const definition: LocaleDefinition = {
  code: 'ru-RU',
  messages,
  dateFnsLocale: ru,
};

export default definition;
